export default "__VITE_ASSET__39f14b84__"